export default class {
  id: string;

  title: string;

  boundEmails: string[];

  boundJustificationIds: string[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.title = obj.title || '';
    this.boundEmails = obj.boundEmails || [];
    this.boundJustificationIds = obj.boundJustificationIds || [];
  }
}
